import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <div>{translate('ra.action.loading')}</div>
  }
  if (error) {
    return <div>{translate('ra.notification.http_error')}</div>
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.billing')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <ShowListElement label={translate('ra.field.address')} value={record.address} />
          <ShowListElement label={translate('ra.field.region')} value={record.region} />
          <ShowListElement label={translate('ra.field.email')} value={record.email} />
          <ShowListElement label={translate('ra.field.type_responsible')} value={record.type_responsible} />
          <ShowListElement label={translate('ra.field.document_type')} value={record.document_type} />
          <ShowListElement label={translate('ra.field.document_number')} value={record.document_number} />
          <ShowListElement label={translate('ra.field.phone_number')} value={record.phone_number} />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const BillingShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} actions={null} className='CrudShowContainer'>
      <ShowContent {...props} />
    </Show>
  )
}
